import { render, staticRenderFns } from "./QuickActionButton.vue?vue&type=template&id=9ded3320"
import script from "./QuickActionButton.vue?vue&type=script&lang=js"
export * from "./QuickActionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports